import Modal from "react-bootstrap/Modal";
import React from 'react'


const ContactModal = ({ contactShow, setContactShow, ...props }) => {
  return (
    <div>
        <Modal
          {...props}
          size="lg"
          className="modal"
          show={contactShow}
          onHide={() => setContactShow(false)}
          aria-labelledby="about-us"
          centered
        >
          <Modal.Header className="modal-header" closeButton>
            <Modal.Title id="contact-us" className="modal-title">
              Contact Us
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body">
            <label className="label my-2">WhatsApp/Call:</label>
            <p className="contact-text">+234 810 743 8151
               <a href="https://wa.link/qnt5ga" target="_blank" rel="noopener noreferrer" className="mx-2">
                <img src="/link-solid-full.svg" alt="link icon" style={{ width: "20px", height: "20px" }} />
              </a>
            </p>

            <label className="label my-2">Instagram:</label>
            <p className="contact-text">
              https://www.instagram.com/Quickplanners

              <a href="https://www.instagram.com/Quickplanners" target="_blank" rel="noopener noreferrer" className="mx-2">
                <img src="/link-solid-full.svg" alt="link icon" style={{ width: "20px", height: "20px" }} />
              </a>
            </p>
            
            <label className="label my-2">Facebook: </label>
            <p className="contact-text">
              https://www.facebook.com/Quickplannersapp
              <a href=" https://www.facebook.com/Quickplannersapp" target="_blank" rel="noopener noreferrer" className="mx-2">
                <img src="/link-solid-full.svg" alt="link icon" style={{ width: "20px", height: "20px" }} />
              </a>
            </p>
          </Modal.Body>
        </Modal>
    </div>
  )
}

export default ContactModal